module.exports = __webpack_public_path__ + "img/COMMUNICATION.24ed393c.svg";